import { FC, FormEvent } from "react";
import { Button } from "../../components/Button";
import LogoSvg from "../../static/images/logo.svg";
import "./style.css";

interface Props {
  handleSubmit: (event: FormEvent<HTMLFormElement>) => void;
}

export const BasicLoginPage: FC<Props> = ({ handleSubmit }) => {
  return (
    <div className="login-page">
      <div className="logo-wrapper">
        <img src={LogoSvg} alt="HCP Logo" className="logo-wrapper-logo" />
        <h6>Tools</h6>
      </div>
      <form onSubmit={handleSubmit} className="login-form">
        <input type="text" name="uname" required />
        <input type="password" name="password" required />
        <Button>Login</Button>
      </form>
    </div>
  );
};
